import React from 'react';
import LandingLayout from '../components/Layout/LandingLayout';
import { LandingModals } from '../components/Landing';
import { SEOHead } from '../components/common';
import { useLandingPageState } from '../hooks/usePage';
import { useTranslation } from 'react-i18next';

const LandingPage = () => {
  const state = useLandingPageState();
  const { t } = useTranslation();

  return (
    <>
      <SEOHead 
        title={t('seo.title')}
        description={t('seo.description')}
        keywords={t('seo.keywords')}
        url="https://tubedigest.ai/"
      />
      
      {/* All Modals */}
      <LandingModals {...state} />

      {/* Main Layout */}
      <LandingLayout {...state} />
    </>
  );
};

export default LandingPage; 